import React from "react"

import { useStaticQuery, graphql } from "gatsby"
import { FlexGrid, FlexRow, FlexCol } from "../FlexGrid"

import {
  RelatedPagesButton,
  RelatedPagesTeaser,
  RelatedPagesContainer,
  RelatedPagesTitle,
} from "./style"

const RelatedPages = ({ relatedContent }) => {
  console.log('relatedContent:', relatedContent)
  return (
    <RelatedPagesContainer>
      <FlexGrid gap={[0, 40]} rowGap={[30, 47]}>
        <FlexRow>
          <FlexCol xs={12}>
            <RelatedPagesTitle>Related Pages</RelatedPagesTitle>
          </FlexCol>
        </FlexRow>
        <FlexRow>
          {relatedContent && relatedContent.pages && relatedContent.pages.map((data, index) => {

            if(!data) return null;
            
            return (
              <FlexCol xs={12} sm={4} key={index}>
                <RelatedPagesTeaser
                  title={data.title}
                  excerpt={data.excerpt}
                  img={data.featuredImage}
                  innerLinkText="Read more"
                  link={data.link}
                />
              </FlexCol>
            )
          })}
        </FlexRow>
      </FlexGrid>
    </RelatedPagesContainer>
  )
}

export default RelatedPages
